import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function CurrencySelector({
  currency,
  disabled,
  onCurrencyChange,
  price: { usd, points, token },
  session }) {

  var buttons = [];
  if (usd) {
    buttons.push(<CurrencyButton currency="USD" disabled={disabled} icon="dw-dollars" key="usd" onClick={(e) => { e.stopPropagation(); onCurrencyChange("usd"); }} selected={currency === "usd"} />);
  }
  if (token) {
    buttons.push(<CurrencyButton currency="Tokens" disabled={disabled || !session.get("token_types") || !session.get("token_types").includes(token)} icon="dw-token" key="token" onClick={(e) => { e.stopPropagation(); onCurrencyChange("token"); }} selected={currency === "token"} />);
  }
  if (points) {
    buttons.push(<CurrencyButton currency="Points" disabled={disabled || session.get("point_balance") < points} icon="dw-points-solid" key="points" onClick={(e) => { e.stopPropagation(); onCurrencyChange("points"); }} selected={currency === "points"} />);
  }

  return (
    <div className="btn_group btn_group--sleek">
      {buttons}
    </div>
  );
});

var CurrencyButton = pure(function CurrencyButton({ currency, disabled, icon, onClick, selected}) {
  var clickHandler = (e) => {
    if (!disabled) {
      onClick(e);
    }
  };
  return (
    <div className="btn_group_item">
      <button
        className={classes({
          "btn": true,
          "btn--small": true,
          "btn--is-selected": selected,
          "btn--is-disabled": disabled,
          "tooltip": true
        })}
        data-tooltip={"Use " + currency + " to enter this tournament."}
        onClick={clickHandler}
        type="button">
        <i className={classes({
          [icon]: true,
          "dw--1-25x": true
        })} />
      </button>
    </div>
  );
});
